<template>
  <combobox-base
    @input="$emit('input', $event)"
    :query="query"
    :itemsGetter="itemsGetter"
    :value="value"
    label="Jazyk"
  ></combobox-base>
</template>

<script>
import { useCompanyLanguagesQuery } from "@/generated/backend";
import { useResult } from "@vue/apollo-composable";
import ComboboxBase from "./ComboboxBase.vue";
import { useCompanyPilverLanguagesQuery } from "../../generated/backend";
export default {
  components: { ComboboxBase },
  props: {
    value: { type: String },
    type: { type: String },
  },
  setup(props) {
    return {
      query: (v) =>
        props.type === "Pilver"
          ? useCompanyPilverLanguagesQuery()
          : useCompanyLanguagesQuery(),
      itemsGetter: (result) =>
        props.type === "Pilver"
          ? useResult(result, [], (d) => d.companyPilverLanguages)
          : useResult(result, [], (d) => d.companyLanguages),
    };
  },
};
</script>
<style></style>
